module.exports = __webpack_public_path__ + "img/none_bg.07e51ea9.png";